import React from 'react';

export default function ActiveLoansManagement({
  selectedTile,
  userId,
  getBankLoans
}) {
  if (!selectedTile || selectedTile.type !== 13 || !selectedTile.owner || selectedTile.owner.owner !== userId) {
    return null;
  }

  const bankLoans = getBankLoans ? getBankLoans(selectedTile.key) : [];

  return (
    <div style={{
      marginBottom: '15px',
      padding: '10px',
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
      borderRadius: '5px',
      border: '1px solid rgba(255, 255, 255, 0.3)'
    }}>
      <h5 style={{ margin: '0 0 10px 0', fontSize: '0.85em', color: '#E8F5E8', wordWrap: 'break-word' }}>
        📋 Active Loans
      </h5>
      
      {bankLoans.length > 0 ? (
        <>
          <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
            {bankLoans.map((loan, index) => {
              const timeRemaining = Math.max(0, Math.ceil((new Date(loan.loanExpirationTime) - new Date()) / 1000 / 60));
              return (
                <div 
                  key={index}
                  style={{
                    fontSize: '0.7em',
                    marginBottom: '8px',
                    padding: '6px',
                    backgroundColor: 'rgba(255, 255, 255, 0.05)',
                    borderRadius: '3px',
                    border: '1px solid rgba(255, 255, 255, 0.1)'
                  }}
                >
                  <div style={{ color: '#C8E6C9', marginBottom: '2px' }}>
                    <strong>{loan.borrowerName || 'Unknown'}</strong>
                  </div>
                  <div style={{ color: '#E8F5E8', marginBottom: '2px' }}>
                    Principal: ${loan.principalAmount?.toLocaleString() || '0'}
                  </div>
                  <div style={{ color: '#FFB74D', marginBottom: '2px' }}>
                    Remaining: ${loan.remainingAmount?.toLocaleString() || '0'}
                  </div>
                  <div style={{ color: '#90EE90', marginBottom: '2px' }}>
                    Rate: {loan.interestRate}% per min
                  </div>
                  <div style={{ color: timeRemaining <= 2 ? '#FF6B6B' : '#C8E6C9' }}>
                    Expires in: {timeRemaining} min{timeRemaining !== 1 ? 's' : ''}
                  </div>
                </div>
              );
            })}
          </div>
          <div style={{ fontSize: '0.7em', color: '#C8E6C9', marginTop: '10px', paddingTop: '10px', borderTop: '1px solid rgba(255, 255, 255, 0.2)' }}>
            <strong>Total Loans Outstanding: ${bankLoans.reduce((sum, loan) => sum + loan.remainingAmount, 0).toLocaleString()}</strong>
          </div>
        </>
      ) : (
        <div style={{ 
          fontSize: '0.75em', 
          color: 'rgba(255, 255, 255, 0.7)',
          textAlign: 'center',
          fontStyle: 'italic',
          padding: '10px',
          backgroundColor: 'rgba(255, 255, 255, 0.05)',
          borderRadius: '4px'
        }}>
          No active loans at this bank
        </div>
      )}
    </div>
  );
}
